import React from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';
import { ReviewEntity } from 'client/data/models/dealer-reviews';
import { createDate } from 'site-modules/shared/utils/date-utils';
import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';
import { TIME } from 'client/utils/time';
import { stripHTML } from 'site-modules/shared/utils/strip-html';
import { ContentCollapse } from 'site-modules/shared/components/content-collapse/content-collapse';

/**
 * Shows review text, author and rating.
 * @param reviews
 * @param [max]
 * @returns {ReactElement}
 */
export function DealerReviewsList({ reviews = [], max = 3, isMobile = false }) {
  return (
    <div className="text-gray-darker">
      {reviews.slice(0, max).map(({ title, text, created, author, rating, createdIso, updatedIso, updated }) => {
        const showUpdatedString = !!updatedIso && createDate(updatedIso) - createDate(createdIso) > TIME.MS.FIVE_DAYS;
        const collapseThreshold = isMobile ? 175 : 350;
        const hasCollapse = stripHTML(text).length > collapseThreshold;
        const textParagraph = <p className="review-text size-16 mb-0">{text}</p>;

        return (
          <div key={`${author}${created}`} className="mb-1_5">
            <h4 className="heading-5 fw-medium mb-0">{title}</h4>
            <RatingStars rating={rating} className="text-primary-darker medium" starClass="ms-0" />
            <span className="small text-gray-darker ps-0_25">
              by {author} on {dateFormat(created, 'm/dd/yyyy')}
            </span>
            {showUpdatedString && (
              <div className="d-inline-block small px-0_25 ms-0_25 text-white bg-primary-darker rounded">
                updated {updated}
              </div>
            )}

            {hasCollapse ? (
              <ContentCollapse
                minHeight="4.125rem" // 3 lines
                isEclipseFade={false}
                btnClasses="px-0_5 py-0 mt-0_25 size-16 text-blue-40"
                btnContainerClasses="py-0"
                justify="justify-content-start"
                showBtnBelow
                btnTextClasses="fw-normal text-primary-darker"
                classes="size-16"
                ariaLabelHeading={`of review: ${title}`}
                btnTrackingId="view_dealer_review"
                isOnlyExpandTracking
                isSameExpandCollapseTracking
                btnIgnoreTrackingValue={false}
                trackingId={null}
              >
                {textParagraph}
              </ContentCollapse>
            ) : (
              textParagraph
            )}
          </div>
        );
      })}
    </div>
  );
}

DealerReviewsList.propTypes = {
  reviews: PropTypes.arrayOf(ReviewEntity),
  max: PropTypes.number,
  isMobile: PropTypes.bool,
};
